import { StackingLevel } from "fe-common/ui/stacking";

export const patientTopBarZIndex = 1500;

export const patientPopupZIndex = patientTopBarZIndex + StackingLevel.HIGH;

export const patientNewVersionZIndex = patientPopupZIndex + StackingLevel.LOW;
